import { render, staticRenderFns } from "./RssFeeds.vue?vue&type=template&id=c7fbefaa&"
import script from "./RssFeeds.vue?vue&type=script&lang=js&"
export * from "./RssFeeds.vue?vue&type=script&lang=js&"
import style0 from "./RssFeeds.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports